webpackJsonp([7669991760471],{

/***/ 1647:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AnalyticsDataRowBreakdown","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"value","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-analytics-data-row-breakdown-b7f4370af5b7cab074d7.js